import { Step } from "@shared/types/setup";
import { Building2, Globe, MapPin } from "lucide-react";

const stepIcons: Record<Step, React.ComponentType<{ className?: string }>> = {
  [Step.Bank]: Building2,
  [Step.Address]: MapPin,
  [Step.Provider]: Globe,
};

export { stepIcons };
